export default {
  section: {
    border: 'Outlines',
    tilt: 'Shadows',
    color: 'Colors',
    background: 'Frame',
  },
  tooltip: {
    show: 'Show',
    hide: 'Hide',
    delete: 'Delete',
    clear: 'Clear',
    opacity: 'Change frame opacities',
    brightness: 'Changer brightness',
    add_type: 'Add a layer for "{{type}}"',
    add: 'Add a layer',
    download: 'Download the plan',
    upload: 'Importer a plan',
  },
  notification: {
    upload_failed: 'The imported file is not valid',
  },
  file: {
    project_name: 'my project',
    mime_description: 'Vertical Topo Project',
  },
}
